import Vue from "vue";

// event bus
const $EventBus = new Vue({
  methods: {
    listen(target, event, callback) {
      this.$on(event, callback);
      target.$on("hook:beforeDestroy", () => {
        this.$off(event, callback);
      });
      return this;
    },
  },
});

export default $EventBus;
